



































































// vue
import { onMounted, defineComponent, ref } from '@vue/composition-api';

// components
import EditorDropdown from '@/vue3/components/editor/EditorDropdown.vue';

// configs
import geoRecordFilter from '@/vue3/configs/geoRecordFilter';

// primevue
import Button from 'primevue/button';
import InputText from 'primevue/inputtext/InputText';
import { useService } from '../api/services';
import Surface from '@/vue3/components/Surface.vue';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import ProgressSpinner from 'primevue/progressspinner';
import { useNotify } from '../hooks/notifyHook';

export default defineComponent({
    components: {
        EditorDropdown,
        Button,
        InputText,
        Surface,
        Accordion,
        AccordionTab,
        ProgressSpinner,
    },
    props: {
        accounts: {
            type: Array,
            default: () => [],
        },
        filterData: {
            type: Array,
            default: () => {},
        },
        geoRecords: {
            type: Array,
            default: () => [],
        },
        mapbox: {
            type: Object,
            default: null,
        },
        layerTree: {
            type: Object,
            default: null,
        },
    },
    setup(props: any) {
        // hooks
        const { deleteGeoRecordFilter, getGeoRecordFilter } = useService();
        const { successToast, errorToast } = useNotify();

        // refs
        const filter = ref({});
        const filters = ref<any[]>([]);
        const allSavedFilter = ref<any[]>([]);

        // reactive
        const isLoading = ref(true);
        const allGeoRecordLayers = ref();

        var geoRecordFilterNew = geoRecordFilter;

        // methods
        const applyFilter = (key: any) => {
            clearFilter();
            key.filter.forEach((filterSelector: any) => {
                addFilter(filterSelector);
            });
        };

        const addFilter = (filterSelector) => {
            filter.value['name'] = filterSelector.filterField;
            geoRecordFilterNew = geoRecordFilterNew.filter((x: any) => {
                if (x.name !== filterSelector.filterField) {
                    return x;
                }
            });
            filter.value['optionLabel'] = filterSelector.filterField;
            filter.value['isOperator'] = true;

            filter.value['name'] = filterSelector.filterField;
            geoRecordFilterNew = geoRecordFilterNew.filter((x: any) => {
                if (x.name !== filterSelector.filterField) {
                    return x;
                }
            });
            filter.value['optionLabel'] = filterSelector.filterField;
            filter.value['isOperator'] = true;

            if (
                filterSelector.filterField == 'accountId' ||
                filterSelector.filterField == 'statusId' ||
                filterSelector.filterField == 'geoRecordCategoryId'
            ) {
                filterSelector.filterValue = Number(filterSelector.filterValue);
            } else if (
                filterSelector.filterField == 'projectId' &&
                !Array.isArray(filterSelector.filterValue)
            ) {
                let val = filterSelector.filterValue.split(',');

                var arr: any = [];

                val.forEach((valArr: any) => {
                    arr.push(Number(valArr));
                });
                filterSelector.filterValue = arr;
            }

            if (
                filterSelector.filterField == 'accountId' ||
                filterSelector.filterField == 'statusId' ||
                filterSelector.filterField == 'geoRecordCategoryId'
            ) {
                filterSelector.filterValue = Number(filterSelector.filterValue);
            } else if (
                filterSelector.filterField == 'projectId' &&
                !Array.isArray(filterSelector.filterValue)
            ) {
                let val = filterSelector.filterValue.split(',');

                var arr_1: any = [];

                val.forEach((valArr: any) => {
                    arr_1.push(Number(valArr));
                });
                filterSelector.filterValue = arr_1;
            } else if (filterSelector.filterField == 'isTask') {
                filterSelector.filterValue =
                    filterSelector.filterValue == 'true';
            }

            filter.value['displayValue'] = filterSelector.filterValue;
            filter.value['value'] = filterSelector.filterValue;
            filter.value['operator'] = filterSelector.filterCondition;

            if (
                filterSelector.filterCondition == 'in' ||
                filterSelector.filterCondition == '==' ||
                filterSelector.filterCondition == 'equal'
            ) {
                filter.value['operatorId'] = '==';
                filter.value['operatorValue'] = 'equal (=)';
            } else if (
                filterSelector.filterCondition == 'not in' ||
                filterSelector.filterCondition == '!==' ||
                filterSelector.filterCondition == 'not equal'
            ) {
                filter.value['operatorId'] = '!==';
                filter.value['operatorValue'] = 'does not equal (!=)';
            }

            filters.value.push(filter.value);

            filter.value['expression'] = generateFilterExpression(filter.value);

            filterSelector.value = null;
            filter.value = {};
        };

        const generateFilterExpression = (expression: any) => {
            allGeoRecordLayers.value =
                props.mapbox.map.getSource('geo-records')._data.features;
            let operator = '';
            if (expression.operator === 'contains') {
                operator = 'in';
            } else if (expression.operator === 'equals') {
                operator = '==';
            } else {
                operator = expression.operator;
            }
            if (expression.operator === undefined) {
                operator = 'in';
            }
            let exp: any[] = [];

            if (operator === 'in' && !Array.isArray(expression.value)) {
                exp = [
                    operator,
                    expression.value,
                    ['get', expression.optionLabel],
                ];
            } else {
                exp = [
                    operator,
                    ['get', expression.optionLabel],
                    Array.isArray(expression.value)
                        ? ['literal', expression.value]
                        : expression.value,
                ];
            }

            allGeoRecordLayers.value.forEach((element) => {
                switch (expression.optionLabel) {
                    case 'accountId': {
                        if (expression.operator === 'equal (=)') {
                            if (element.properties.accountId !== exp[2]) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        } else if (
                            expression.operator === 'does not equal (!=)'
                        ) {
                            if (element.properties.accountId == exp[2]) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        }
                        break;
                    }
                    case 'projectId': {
                        if (expression.operator === 'equal (=)') {
                            if (
                                !exp[2][1].includes(
                                    element.properties.projectId,
                                )
                            ) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        } else if (
                            expression.operator === 'does not equal (!=)'
                        ) {
                            if (
                                exp[2][1].includes(element.properties.projectId)
                            ) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        }
                        break;
                    }
                    case 'isTask': {
                        if (expression.operator === 'equal (=)') {
                            if (element.properties.isTask !== exp[2]) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        } else if (
                            expression.operator === 'does not equal (!=)'
                        ) {
                            if (element.properties.isTask == exp[2]) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        }
                        break;
                    }
                    case 'statusId': {
                        if (expression.operator === 'equal (=)') {
                            if (element.properties.statusId !== exp[2]) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        } else if (
                            expression.operator === 'does not equal (!=)'
                        ) {
                            if (element.properties.statusId == exp[2]) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        }
                        break;
                    }
                    case 'assigneeAccountId': {
                        if (expression.operator === 'equal (=)') {
                            if (
                                '' + element.properties.assigneeAccountId !==
                                exp[2]
                            ) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        } else if (
                            expression.operator === 'does not equal (!=)'
                        ) {
                            if (
                                '' + element.properties.assigneeAccountId ==
                                exp[2]
                            ) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        }
                        break;
                    }
                    case 'geoRecordCategoryId': {
                        if (expression.operator === 'equal (=)') {
                            if (
                                element.properties.geoRecordCategoryId !==
                                exp[2]
                            ) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        } else if (
                            expression.operator === 'does not equal (!=)'
                        ) {
                            if (
                                element.properties.geoRecordCategoryId == exp[2]
                            ) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        }
                        break;
                    }
                    case 'title': {
                        if (expression.operator === 'equal (=)') {
                            if (
                                !element.properties.title
                                    .toLowerCase()
                                    .includes(exp[2].toLowerCase())
                            ) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        } else if (
                            expression.operator === 'does not equal (!=)'
                        ) {
                            if (
                                element.properties.title
                                    .toLowerCase()
                                    .includes(exp[2].toLowerCase())
                            ) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        }
                        break;
                    }
                    case 'geoRecordTagId': {
                        let tag = parseInt(exp[2]);

                        if (expression.operator === 'equal (=)') {
                            if (!element.properties.tagIds) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            if (
                                element.properties.tagIds &&
                                !element.properties.tagIds.includes(tag)
                            ) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        } else if (
                            expression.operator === 'does not equal (!=)'
                        ) {
                            if (
                                element.properties.tagIds &&
                                element.properties.tagIds.includes(tag)
                            ) {
                                props.layerTree.geoRecordNodeDeSelect(
                                    element,
                                    true,
                                );
                            }
                            return;
                        }
                        break;
                    }
                    default: {
                        if (!element.properties.title.includes(exp[1])) {
                            props.layerTree.geoRecordNodeDeSelect(
                                element,
                                true,
                            );
                        }
                    }
                }
            });

            return exp;
        };

        const deleteFilter = async (key: any) => {
            try {
                isLoading.value = true;
                await deleteGeoRecordFilter(key);
                successToast('Geo Record Filter deleted successfully');
            } catch (e) {
                console.log(e);
            } finally {
                allSavedFilter.value = await getGeoRecordFilter();
                isLoading.value = false;
            }
        };

        const clearFilter = () => {
            if (allGeoRecordLayers.value) {
                allGeoRecordLayers.value.forEach((element) => {
                    props.layerTree.geoRecordNodeSelect(element, true);
                });
                allGeoRecordLayers.value = [];
                filters.value = [];
            }
        };

        onMounted(async () => {
            try {
                allSavedFilter.value = await getGeoRecordFilter();
            } catch (e) {
                console.log(e);
                allSavedFilter.value = [];
            }

            allGeoRecordLayers.value =
                props.mapbox.map.getSource('geo-records')._data.features;

            isLoading.value = false;
        });

        return {
            filters,
            addFilter,
            deleteFilter,
            applyFilter,
            allSavedFilter,
            clearFilter,
            isLoading,
        };
    },
});
